import get from 'lodash/get';

export const isImage = asset =>
  get(asset, 'filetype', '').indexOf('image') > -1;

/**
 * @public
 */

export const isVideo = asset =>
  get(asset, 'filetype', '').indexOf('video') > -1;

export const isDocument = asset => !(isImage(asset) || isVideo(asset));
